import React, { useState } from 'react';

const TemplateCard = ({ template, category, isSelected, onSelect, onApply, onEdit, onCopy, onDelete }) => {
  const [isPreviewExpanded, setIsPreviewExpanded] = useState(false);

  const getCategoryColor = () => {
    switch (category) {
      case 'provider': return '#0e71eb'; // Blue
      case 'health_system': return '#ff9800'; // Orange/Yellow  
      case 'global': return '#4caf50'; // Green
      default: return '#666';
    }
  };

  const getCategoryLabel = () => {
    switch (category) {
      case 'provider': return 'My Templates';
      case 'health_system': return 'Healthcare';
      case 'global': return 'System';
      default: return 'Unknown';
    }
  };

  const canEdit = category === 'provider';
  const canCopy = category !== 'provider';

  return (
    <div className={`template-item ${isSelected ? 'selected' : ''}`} onClick={() => onSelect(template)}>
      <div className="template-card-header">
        <div className="template-name">
          {template.name}
          {template.is_default && <span style={{ marginLeft: '8px', fontSize: '12px', color: '#ff9800' }}>⭐ Default</span>}
          {template.is_favorite && <span style={{ marginLeft: '8px', fontSize: '12px', color: '#e91e63' }}>❤️ Favorite</span>}
        </div>
        <div className="category-badge" style={{ backgroundColor: getCategoryColor(), color: 'white', padding: '2px 8px', borderRadius: '12px', fontSize: '11px', fontWeight: '500' }}>{getCategoryLabel()}</div>
      </div>

      <div className="template-description">{template.description || 'No description available'}</div>

      <div className="template-type">{template.template_type === 'full' ? 'Full Note Template' : template.template_type === 'section' ? 'Section Template' : template.template_type || 'Custom Template'}</div>

      {template.specialties && template.specialties.length > 0 && (
        <div className="template-specialties" style={{ marginTop: '8px', marginBottom: '8px' }}>
          {template.specialties.map(specialty => (
            <span key={specialty.id || specialty.name} className="specialty-bubble">
              {specialty.name || specialty}
            </span>
          ))}
        </div>
      )}

      {/* Show associations for health system templates */}
      {template.associations && (
        <div className="template-associations" style={{ marginTop: '8px', marginBottom: '8px', fontSize: '11px', color: '#666' }}>
          {template.associations.departments && template.associations.departments.length > 0 && (
            <div>📁 Departments: {template.associations.departments.join(', ')}</div>
          )}
          {template.associations.clinics && template.associations.clinics.length > 0 && (
            <div>🏥 Clinics: {template.associations.clinics.join(', ')}</div>
          )}
          {template.associations.specialties && template.associations.specialties.length > 0 && (
            <div>⚕️ Specialties: {template.associations.specialties.join(', ')}</div>
          )}
        </div>
      )}

      {/* Scrollable Preview */}
      <div className="template-preview-scroller">
        {template.content || 'No content preview available'}
        {/* Fade gradient overlay */}
        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: '1rem', background: 'linear-gradient(transparent, #f9f9f9)', pointerEvents: 'none' }} />
      </div>

      {/* Action Buttons */}
      <div className="template-actions">
        <button className="button primary" style={{ fontSize: '12px', padding: '4px 12px' }} onClick={(e) => { e.stopPropagation(); onApply(template, 'full'); }}>Apply</button>
        {canEdit && <button className="button" style={{ fontSize: '12px', padding: '4px 12px' }} onClick={(e) => { e.stopPropagation(); onEdit(template); }}>Edit</button>}
        {canCopy && <button className="button" style={{ fontSize: '12px', padding: '4px 12px' }} onClick={(e) => { e.stopPropagation(); onCopy(template); }}>Copy</button>}
        {canEdit && <button className="button" style={{ fontSize: '12px', padding: '4px 12px', color: '#dc3545', borderColor: '#dc3545' }} onClick={(e) => { e.stopPropagation(); onDelete(template); }}>Delete</button>}
      </div>
    </div>
  );
};

export default TemplateCard;